export default __webpack_public_path__ + "static/media/1007.c18928f2.png";